<!-- ✅ Custom Fullscreen Spinner -->
<ngx-spinner
  name="upsSpinner"
  bdColor="rgba(255, 255, 255, 0.8)"
  size="medium"
  color="#321815"
  type="custom"
  [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

@if (isLoading) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<!-- 🔁 Main Content -->
<div class="container">
  @if (!isViewingDetails && historyData.length > 0) {
    <div class="card card-body card-upload-history">
      <ng-container>
        <span class="list-title">Upload History</span>
        <mi-table
          [data]="historyData"
          [searchText]="searchText"
          [isSearchRequired]="true"
          [validationRules]="firstTableValidationRules"
          [actions]="showAction"
          [allowedActions]="['editMain','view','download','digitalCopy']"
          [nonEditableFields]="['Adj Req Id','Details Id','Total Customers','Status','Requested Date','Net Amount','First Level Remarks','Approver','Gbs Status','MI Remarks']"
          (rowUpdated)="onRowUpdate($event)"
          (rowEditCanceled)="onRowEditCancel($event)"
          (actionEvent)="onAction($event)"
          (validationError)="onValidationError($event)"
          [isMaster]="true">
        </mi-table>
      </ng-container>
    </div>
  }

  @if (isViewingDetails) {
    <!-- 🔙 Back Button -->
    <button mat-flat-button color="#f2af2c" class="custom-back-btn" (click)="onBackToHistory()">
      ← Back
    </button>
    <div class="info">
      Please use this button to navigate back to the previous history screen
    </div>
    <!-- 🔼 Top Submit Button (right-aligned) -->
    @if (isSubmitVisible) {
      <div class="mb-3 right-align">
        <button mat-flat-button color="primary" (click)="submitUpdatedRequest()" class="custom-back-btn">
          Submit Changes
        </button>
      </div>
    }
    <!-- 🔸 Show Selected Main Row in Single Row Table -->
    <div class="mb-4 border rounded shadow-sm p-3 bg-light selected-request">
      <h5 class="mb-3 selected-request-title">Selected Request</h5>
      <mi-table
        [data]="[selectedMainRow]"
        [searchText]="searchText"
        [isSearchRequired]="false"
        [validationRules]="firstTableValidationRules"
        [actions]="showAction"
        [allowedActions]="['edit', 'delete']"
        [nonEditableFields]="['Adj Req Id','Details Id','Total Customers','Requested Date','Mi Remarks','Net Amount','First Level Remarks','Approver','Gbs Status','Adjustment Type','Mi Status','Actioned By (MI)','MI Remarks','Status']"
        (rowUpdated)="onRowUpdate($event)"
        (rowEditCanceled)="onRowEditCancel($event)"
        (actionEvent)="onAction($event)"
        (validationError)="onValidationError($event)"
        [isMaster]="true">
      </mi-table>
    </div>
    <!-- 🔹 Details Table for that Request -->
    @if (!isLoading) {
      <div>
        <mi-table
          [data]="detailData"
          [searchText]="searchText"
          [isSearchRequired]="true"
          [validationRules]="detailsValidationTableRules"
          [actions]="showAction"
          [allowedActions]="['edit', 'delete']"
          [nonEditableFields]="['Details Id','Adj Req Id','GBS Status','GBS Remarks','Adjustment Method','MI Status','MI Remarks','Actioned By (GBS)','Actioned By (MI)']"
          (rowUpdated)="onRowUpdate($event)"
          (rowEditCanceled)="onRowEditCancel($event)"
          (actionEvent)="onAction($event)"
          (validationError)="onValidationError($event)"
          [isMaster]="false">
        </mi-table>
      </div>
    }
    <!-- Row 2: Select Files on left, Submit on right -->
    <div class="button-row full-width-row">
      <!-- Row 1: Selected files shown horizontally -->
      <div class="selected-files-wrapper full-width-row">
        @for (file of selectedFiles; track file; let i = $index) {
          <div class="selected-file-list">
            <div class="file-name-box">
              {{ file.name }}
              @if (showAction && selectedMainRow._isAllowEdit) {
                <button
                  type="button"
                  class="close delete-btn"
                  aria-label="Close"
                  (click)="removeFile(i)"
                  >
                  <span aria-hidden="true">&times;</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
      <!-- Select Files Button -->
      @if (selectedMainRow._isAllowEdit && showAction) {
        <div class="select-files-container">
          <input type="file" multiple (change)="getFileDetails($event)" hidden #fileInput />
          <button
            type="button"
            class="custom-button same-size-btn"
            (click)="fileInput.click()"
            [disabled]="(!showAction) || selectedFiles.length > 5">
            <i class="material-icons">attach_file</i> Select Files
          </button>
        </div>
      }
      <!-- Submit Button -->
      @if (isSubmitVisible) {
        <div class="submit-btn-container">
          <button class="save-request-btn same-size-btn" (click)="submitUpdatedRequest()">
            <i class="material-icons">save</i> Submit
          </button>
        </div>
      }
    </div>
    @if (selectedMainRow._isAllowEdit && showAction) {
      <div class="file-upload-info">
        <span class="text-danger">{{ fileErrors }}</span><br />
        <span class="hint-text">Supported file types: csv, pdf, txt, xlsx, eml, msg</span><br />
        <span class="hint-text">Size limit: 500MB per file, up to 5 files.</span>
      </div>
    }
  }
</div>
